import React from "react";
import { LoginCallback } from "@okta/okta-react";
import { useNavigate } from "react-router-dom";

interface OAuthError extends Error {
  error?: string;
  errorCode?: string;
}

const CustomLoginCallback: React.FC = () => {
  const navigate = useNavigate();

  return (
    <LoginCallback
      errorComponent={({ error }) => {
        const err = error as OAuthError;

        if (err) {
          if (err.error === "use_dpop_nonce" || err.errorCode === "use_dpop_nonce") {
            return null;
          }

          const errorType: "DPoP" | "NONCE" =
            err.error === "invalid_dpop_proof" || err.errorCode === "invalid_dpop_proof"
              ? "DPoP"
              : "NONCE";

          navigate("/error", { state: { errorType } });
          return null;
        }

        // No error — navigate to root
        navigate("/", { replace: true });
        return null;
      }}
    />
  );
};

export default CustomLoginCallback;
